// @flow strict
import * as React from 'react';

const HighlightMessageContext = React.createContext<?string>();

export default HighlightMessageContext;
